import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { downloadViaAnchor } from 'src/data-capture/file-management/utils/downloadViaAnchor';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';

type DownloadVariables = { fileId: string; filename: string };

export default function useDownloadSkillFile(skillId: string) {
  const { mutateAsync, isPending, variables } = useMutation<void, Error, DownloadVariables>({
    mutationFn: ({ fileId, filename }) =>
      downloadViaAnchor(
        async (id: string) => {
          const { data } = await api.get<{ url: string }>(
            `/tenant/custom-skills/${skillId}/files/${id}/download`,
          );
          return data;
        },
        fileId,
        filename.split('/').pop(),
      ),
  });

  const downloadFile = async (fileId: string, filename: string) => {
    try {
      await mutateAsync({ fileId, filename });
    } catch (error) {
      notifyAndLogError('Failed to download file', 'The file could not be downloaded.', error, {
        skillId,
        fileId,
      });
    }
  };

  return { downloadFile, pendingFileId: isPending ? variables?.fileId : null };
}
